<div class="input-currency">
    <input
    id="inputPayment"
    [ngClass]="{'input-currency-recharge': inputModel.isInputCurrencyRecharge,
                'input-payment': !inputModel.isInputCurrencyRecharge,
                'input-currency-reembolso': inputModel.isInputCurrencyReembolso}" 
    type="{{ inputModel.type }}"
    [textMask]="{mask: inputModel.maskRule, guide: false}" 
    placeholder="{{ inputModel.placeholder }}" 
    [formControl]="authInputFormControl" 
    [(ngModel)]="value" 
    (ngModelChange)="sendValue()" 
    (change)="isValid()" />
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input-currency/input-currency.component.html